import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as WhatsappIcon } from '../../../../assets/svg/icons/whatsapp.svg';
import { ReactComponent as PhoneIcon } from '../../../../assets/svg/icons/chiamate.svg';
import styles from './TaskInfoModal.module.scss';
import { schedulerActions } from '../../store';
import { modalActions } from '../../../Modals/store';
import dayjs from 'dayjs';
import { getTaskById, infoRiccorrenzaSelect } from '../../store/selectors';
import useWindowSize from '../../../../utils/useWindowSize';
import clsx from 'clsx';
import IconButton from '../../../Common/Buttons/IconButton';
import { badgetList, paymentMethodList, selectBadges } from '../../constants';
import { Badgets } from '../../../Common/Badgets';
import { ReactComponent as Person } from '../../../../assets/svg/icons/profilo.svg';
import { ReactComponent as BadIcon } from 'assets/svg/icons/warning_user.svg';
import { ReactComponent as Plus } from '../../../../assets/svg/plus_circle_blue.svg';
import { ReactComponent as EditBlack } from '../../../../assets/svg/icons/modifica.svg';
import { ReactComponent as Bin } from '../../../../assets/svg/icons/trash_red.svg';

import ConfirmSecondaryModal from '../../../Common/ConfirmSecondaryModal';
import { ReactComponent as Verified } from '../../../../assets/svg/verified.svg';
import HoveredInfoIcon from 'Containers/Common/HoveredInfoIcon';
import { useTranslation } from 'react-i18next';
import EditNote from 'Containers/Clients/containers/ClientModal/EditNote';
import DeleteNote from 'Containers/Clients/containers/ClientModal/DeleteNote';
import { getClient } from 'Containers/Clients/store/selectors';
import { clientActions } from 'Containers/Clients/store';
import SpinnerSmall from 'Containers/Common/SpinnerSmall';
import { getActiveSalonId } from 'Containers/Auth/store/selectors';
import { Api } from '../../../../entries/ApiTransport';
import ExploreTaglioRow from './ExploreTaglioRow';
import { isCalendarBreak } from '../utils/taskDisplay';

const api = Api.getInstance();


const TaskInfoModal = ({ taskValue: { day, workerId, task, isBadClient, searchParams }, closeModal }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const price = JSON.parse(localStorage.getItem('currentPrice') || 0);
  const [confirmationModalIsOpen, setConfirmationModalIsOpen] = useState(false);
  const taskToEdit = useSelector(getTaskById(task.idprenotazione));
  const isBreak = isCalendarBreak(taskToEdit);
  const [paymentMethod, setPaymentMethod] = useState(taskToEdit.salon_method_pay);
  const [isAddingNote, setIsAddingNote] = useState(false);
  const [newNoteText, setNewNoteText] = useState('');
  const [isSavingNote, setIsSavingNote] = useState(false);
  const [isEditNoteModalOpen, setIsEditNoteModalOpen] = useState(false);
  const [isDeleteNoteModalOpen, setIsDeleteNoteModalOpen] = useState(false);
  const [isModalNoteData, setIsModalNoteData] = useState({});
  const client_id = taskToEdit.utente;
  const [loadingNotes, setLoadingNotes] = useState(false);
  const [taglioDetail, setTaglioDetail] = useState(null);
  const [loadingTaglio, setLoadingTaglio] = useState(false);
  const [taglioFetchFailed, setTaglioFetchFailed] = useState(false);
  const client = useSelector(getClient());
  const clientNotes = client?.notes;
  const infoRiccorrenza = useSelector(infoRiccorrenzaSelect());
  const activeSalonId = useSelector(getActiveSalonId());
  const isClient = client_id != activeSalonId && !taskToEdit.selfPrenotazione;
  const bookingIdTaglio = taskToEdit?.idTaglio ?? taskToEdit?.idtaglio;

  const removeBooking = (recurrence) => {
    dispatch(
      schedulerActions.DELETE_CALENDAR_TASK.REQUEST({
        deleteAllRicorrenti: recurrence,
        idPoltrona: taskToEdit.poltrona,
        idPrenotazione: taskToEdit.idprenotazione,
        ricorrente: taskToEdit.ricorrente,
      }),
    );
    closeModal();
  };

  const openAddNote = useCallback(() => {
    setIsAddingNote(true);
    setNewNoteText('');
  }, []);

  const cancelAddNote = useCallback(() => {
    setIsAddingNote(false);
    setNewNoteText('');
    setIsSavingNote(false);
  }, []);

  const saveNewNote = useCallback(() => {
    const nota = newNoteText.trim();
    if (!nota || isSavingNote) return;

    setIsSavingNote(true);
    dispatch(
      clientActions.ADD_NOTE.REQUEST(
        {
          idcliente: client_id,
          nota,
        },
        () => {
          dispatch(
            clientActions.GET_CLIENT.REQUEST({ idcliente: client_id }, () => {
              setIsSavingNote(false);
              cancelAddNote();
            }),
          );
        },
      ),
    );
    window.setTimeout(() => setIsSavingNote(false), 2500);
  }, [cancelAddNote, client_id, dispatch, isSavingNote, newNoteText]);

  useEffect(() => {
    if (task?.ricorrente != null) {
      dispatch(
        schedulerActions.GET_DETAILS_PRENOTAZIONE_RICORRENTE.REQUEST({
          guidRicorrenza: task.ricorrente,
        }),
      );
    }
    if (client?.idutente != client_id && isClient) { 
      setLoadingNotes(true);
      dispatch(
        clientActions.GET_CLIENT.REQUEST({
          idcliente: client_id,
        }, () => setLoadingNotes(false)),
      );
    }
  }, [task]);

  useEffect(() => {
    if (!bookingIdTaglio) {
      setTaglioDetail(null);
      setTaglioFetchFailed(false);
      setLoadingTaglio(false);
      return undefined;
    }

    let cancelled = false;
    setLoadingTaglio(true);
    setTaglioFetchFailed(false);
    setTaglioDetail(null);

    api
      .get(`/business/tagli/${bookingIdTaglio}`)
      .then(({ data }) => {
        if (cancelled) return;
        if (data?.taglio) {
          setTaglioDetail(data.taglio);
        } else {
          setTaglioFetchFailed(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setTaglioFetchFailed(true);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoadingTaglio(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [bookingIdTaglio]);


  //funzione burtta per ottenere la data in formato bello
  const convertISOToDate = (ISOString) => {
    const date = new Date(ISOString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getDayTask = (day) => {
    const today = new Date();
    if (dayjs(today).format('YYYY-MM-DD') === day) {
      return 'Oggi';
    } else {
      const date = dayjs(day).format('DD MMM');
      return `${date}`;
    }
  };

  const handleChangePaymentMethod = (value) => {
    dispatch(
      schedulerActions.EDIT_CALENDAR_TASK.REQUEST({
        salon_method_pay: value,
        idPrenotazione: taskToEdit.idprenotazione,
      }, () => {
        setPaymentMethod(value);
      }),
    );
  };
  // console.log('taskToEdit', infoRiccorrenza);
  return (
    <>
      <ConfirmSecondaryModal
        isModalOpen={confirmationModalIsOpen}
        setIsModalOpen={setConfirmationModalIsOpen}
        title={t('scheduler.taskInfoModal.confirmCancel.title')}
        subtitle={
          task?.ricorrente
            ? t('scheduler.taskInfoModal.confirmCancel.recurringSubtitle')
            : t('scheduler.taskInfoModal.confirmCancel.confirmSubtitle')
        }
        buttons={
          task?.ricorrente
            ? [t('scheduler.taskInfoModal.confirmCancel.cancelThis'), t('scheduler.taskInfoModal.confirmCancel.cancelAll')]
            : [t('scheduler.taskInfoModal.confirmCancel.cancel')]
        }
        buttonsActions={[() => removeBooking(false), () => removeBooking(true)]}
      />
      <div
        className={clsx(styles.info_task_modal, {
          [styles.info_task_modal_mobile]: isMobile,
        })}
      >
        <div className={styles.hero}>
          <div className={styles.time_chip}>
            <span className={styles.time_chip_day}>{getDayTask(day.date)}</span>
            <span className={styles.time_chip_range}>
              {dayjs(task.unixStartTime * 1000).format('HH:mm')}
              {' – '}
              {dayjs(task.unixEndTime * 1000).format('HH:mm')}
            </span>
          </div>

          {Object.entries(selectBadges(taskToEdit))?.some(([, value]) => value) ? (
            <div className={styles.special_icons_container}>
              {Object.entries(selectBadges(taskToEdit))?.map(([key, value]) => {
                if (!value) return null;
                return (
                  <Badgets
                    key={key}
                    icon={badgetList[key]?.icon}
                    text={
                      key == 3
                        ? `${badgetList[key]?.text} ${dayjs(taskToEdit.birthday).format('DD MMM')}`
                        : badgetList[key]?.text
                    }
                    type="Large"
                  />
                );
              })}
            </div>
          ) : null}

          {task?.ricorrente && infoRiccorrenza?.fineRicorrenza ? (
            <p className={styles.recurring_hint}>
              {t('scheduler.taskInfoModal.recurringEnds')}{' '}
              {convertISOToDate(infoRiccorrenza?.fineRicorrenza)}
            </p>
          ) : null}
        </div>

        {!(
          searchParams?.get('allowEdit') &&
          searchParams?.get('allowEdit') != 1 &&
          !!localStorage.getItem('staff')
        ) &&
        !(price < 50 || taskToEdit.statusPayment === 2) ? (
          <section className={styles.section}>
            <div className={styles.section_head}>
              <h3 className={styles.section_title}>
                {t('scheduler.taskInfoModal.bookingPaymentMethod')}
              </h3>
              <HoveredInfoIcon
                description={t('scheduler.taskInfoModal.bookingPaymentMethodDescription')}
              />
            </div>
            <div className={styles.payment_row}>
              {paymentMethodList.map((method) => (
                <button
                  key={method.value}
                  type="button"
                  className={clsx(styles.salon_payment_method, {
                    [styles.salon_payment_method_selected]: paymentMethod === method.value,
                  })}
                  onClick={() => handleChangePaymentMethod(method.value)}
                  aria-pressed={paymentMethod === method.value}
                >
                  <span className={styles.salon_payment_icon}>{method.icon}</span>
                  <span className={styles.salon_payment_label}>{t(method.labelKey)}</span>
                </button>
              ))}
            </div>
          </section>
        ) : null}

        <section className={styles.section}>
          <h3 className={styles.section_title}>{t('scheduler.taskInfoModal.bookedServices')}</h3>
          <ul className={styles.services_list}>
            {(taskToEdit.servizi || []).map((service, index) => (
              <li key={`${service.nome}-${index}`} className={styles.service_chip}>
                {service.nome}
              </li>
            ))}
          </ul>
        </section>

        <ExploreTaglioRow
          hasIdTaglio={!!bookingIdTaglio}
          taglio={taglioDetail}
          loading={loadingTaglio}
          fetchFailed={taglioFetchFailed}
        />

        <section className={styles.section}>
          <h3 className={styles.section_title}>{t('scheduler.taskInfoModal.bookingNote')}</h3>
          <div className={styles.note_box}>
            {taskToEdit.nota ? (
              taskToEdit.nota
            ) : (
              <span className={styles.note_empty}>{t('scheduler.taskInfoModal.noNote')}</span>
            )}
          </div>
        </section>

        {isClient ? (
          <>
            <section className={styles.section}>
              <div className={styles.section_head_between}>
                <h3 className={styles.section_title}>
                  {t('scheduler.taskInfoModal.clientNotesHistory')}
                </h3>
                <button
                  type="button"
                  className={styles.aggiungi_nota}
                  onClick={isAddingNote ? cancelAddNote : openAddNote}
                >
                  {isAddingNote
                    ? t('common.actions.cancel')
                    : t('scheduler.taskInfoModal.addNote')}
                  {!isAddingNote ? <Plus /> : null}
                </button>
              </div>

              {isAddingNote ? (
                <div className={styles.note_compose}>
                  <label className={styles.note_compose_label} htmlFor="task-new-note">
                    {t('clients.clientModal.addNote.descriptionLabel')}
                  </label>
                  <textarea
                    id="task-new-note"
                    className={styles.note_compose_input}
                    rows={4}
                    placeholder={t('clients.clientModal.addNote.textareaPlaceholder')}
                    value={newNoteText}
                    onChange={(event) => setNewNoteText(event.target.value)}
                    disabled={isSavingNote}
                    autoFocus
                  />
                  <div className={styles.note_compose_actions}>
                    <button
                      type="button"
                      className={styles.note_compose_cancel}
                      onClick={cancelAddNote}
                      disabled={isSavingNote}
                    >
                      {t('common.actions.cancel')}
                    </button>
                    <button
                      type="button"
                      className={styles.note_compose_save}
                      onClick={saveNewNote}
                      disabled={isSavingNote || !newNoteText.trim()}
                    >
                      {t('common.actions.save')}
                    </button>
                  </div>
                </div>
              ) : null}

              <div className={styles.appointments_history_block}>
                {loadingNotes ? (
                  <SpinnerSmall />
                ) : clientNotes?.length ? (
                  clientNotes.map((note) => (
                    <div key={note.idutentenota} className={styles.appointments_history_row}>
                      <div className={styles.appointments_history_info_cell}>{note?.nota}</div>
                      <div className={styles.appointments_history_date_cell}>
                        {dayjs(note.created_at).format('DD/MM/YY')}
                      </div>
                      <div className={`${styles.appointments_history_info_cell} ${styles.note_cell}`}>
                        <button
                          type="button"
                          className={styles.edit_note}
                          onClick={() => {
                            setIsModalNoteData(note);
                            setIsEditNoteModalOpen(true);
                          }}
                          aria-label={t('common.actions.edit')}
                        >
                          <EditBlack />
                        </button>
                        <button
                          type="button"
                          className={styles.delete_note}
                          onClick={() => {
                            setIsModalNoteData(note);
                            setIsDeleteNoteModalOpen(true);
                          }}
                          aria-label={t('common.actions.delete')}
                        >
                          <Bin />
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className={styles.note_empty}>{t('scheduler.taskInfoModal.noNote')}</div>
                )}
              </div>
            </section>
          </>
        ) : null}

        {taskToEdit.cellulare ? (
          <section className={styles.section}>
            <h3 className={styles.section_title}>{t('scheduler.taskInfoModal.phone')}</h3>
            <div className={styles.phone_value}>
              {taskToEdit.cellulare}
              {taskToEdit.cellulare_verificato ? <Verified /> : null}
            </div>
          </section>
        ) : null}

        <section className={styles.section}>
          <h3 className={styles.section_title}>{t('scheduler.taskInfoModal.bookingTakenOn')}</h3>
          <div className={styles.meta_value}>
            {dayjs(task.createAt).format('DD MMM YYYY')}
            {' · '}
            {dayjs(task.createAt).format('HH:mm')}
          </div>
        </section>

        <section className={styles.section}>
          <h3 className={styles.section_title}>{t('scheduler.taskInfoModal.contactClient')}</h3>
          <div className={styles.info_icons_container}>
            <IconButton
              svg={<WhatsappIcon />}
              type="whatsapp"
              size="48px"
              isActive={!!taskToEdit.cellulare && !isBreak}
              value={taskToEdit?.cellulare}
              margin="0"
            />
            <IconButton
              svg={<PhoneIcon />}
              type="phone"
              size="48px"
              isActive={!!taskToEdit.cellulare && !isBreak}
              value={taskToEdit.cellulare}
              margin="0"
            />
            <div className={styles.client_btn_wrap}>
              {isBadClient ? (
                <BadIcon className={styles.bad_client_badge} aria-hidden />
              ) : null}
              <IconButton
                svg={<Person />}
                type="default"
                size="48px"
                isActive={taskToEdit.utente != taskToEdit.salone && !isBreak}
                onClick={() => {
                  dispatch(
                    modalActions.OPEN_MODAL.SUCCESS({
                      type: 'clientModal',
                      props: { client_id: taskToEdit.utente },
                    }),
                  );
                }}
              />
            </div>
          </div>
        </section>

        <div className={styles.footer_actions}>
          {!!task.isActive &&
          !(searchParams?.get('allowEdit') != 1 && !!localStorage.getItem('staff')) ? (
            <button
              type="button"
              className={styles.edit_action}
              onClick={() => {
                dispatch(
                  modalActions.OPEN_MODAL.SUCCESS({
                    type: 'editTaskModal',
                    props: {
                      day,
                      workerId,
                      task,
                    },
                  }),
                );
              }}
            >
              {t('scheduler.taskInfoModal.editBooking').replace(/\s*>\s*$/, '')}
            </button>
          ) : null}

          {!(
            searchParams?.get('allowEdit') &&
            searchParams?.get('allowEdit') != 1 &&
            !!localStorage.getItem('staff')
          ) ? (
            <button
              type="button"
              className={styles.delete_button}
              onClick={() => setConfirmationModalIsOpen(true)}
            >
              {t('scheduler.taskInfoModal.confirmCancel.cancel')}
            </button>
          ) : null}
        </div>
      </div>
      <EditNote
        isModalOpen={isEditNoteModalOpen}
        setIsModalOpen={setIsEditNoteModalOpen}
        client_id={client_id}
        nota={isModalNoteData}
      />

      <DeleteNote
        isModalOpen={isDeleteNoteModalOpen}
        setIsModalOpen={setIsDeleteNoteModalOpen}
        client_id={client_id}
        nota={isModalNoteData}
      />
    </>
  );
};

export default TaskInfoModal;
